export default "__VITE_ASSET__Dy1L8Z62__"